import { CultureInfo } from '../culture-info.model';
import { CultureInfoEn } from './en';

/**
 * @ignore
 */
export const CultureInfoEnGD: CultureInfo = {
  name: 'en-GD',
  displayName: 'English (Grenada)',
  iso3LanguageCode: 'eng',
  iso2LanguageCode: 'en',
  ietfLanguageTag: 'en-GD',
  parent: CultureInfoEn
};
